/**
 * Created by Alex on 7/17/2025.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ReplaceEntityDialogService {
    dialogOpen$: Subject<any> = new Subject<any>();
    actions$: Subject<any> = new Subject<any>();
}
